import {
  AnswerDiscriminator,
  AnswerStatus,
  AnswerValues,
  Field,
  FieldDiscriminator,
  FilledOutField,
} from './types';

// a form element (chapter or field) must be shown if
// - it is shown unconditionally (= no "enabled by" options)
// - it is enabled because of a selected option
export const formElementMustBeShown = (
  formElement: Field,
  selectedOptionIds: number[],
): boolean =>
  formElement.enabledByOptions.length === 0 ||
  formElement.enabledByOptions.filter((option) =>
    selectedOptionIds.includes(option.id),
  ).length >= 1;

export const getSelectedOptionIds = (
  filledOutFields: FilledOutField[],
): number[] => {
  return filledOutFields.reduce((result, current) => {
    const { field, answer } = current;

    if (
      FieldDiscriminator.SINGLE_CHOICE_FIELD !== field.discr ||
      !answer ||
      answer.discr !== AnswerDiscriminator.CHOICE_FIELD_ANSWER
    ) {
      return result;
    }

    return [...result, ...answer.chosenOptions.map((option) => option.id)];
  }, [] as number[]);
};

export const getAnswerValues = (
  filledOutFields: FilledOutField[],
): AnswerValues => {
  return filledOutFields.reduce((result, current) => {
    const { field, answer } = current;

    if (!answer) {
      return result;
    }

    if (field.discr === FieldDiscriminator.SINGLE_CHOICE_FIELD) {
      return answer.discr === AnswerDiscriminator.CHOICE_FIELD_ANSWER
        ? {
            ...result,
            [String(field.id)]: answer.chosenOptions.map((option) => option.id),
          }
        : result;
    }

    return answer.value
      ? {
          ...result,
          [String(field.id)]: answer.value,
        }
      : result;
  }, {} as AnswerValues);
};

export const getAnswerIdsByStatus = (
  filledOutFields: FilledOutField[],
  status: AnswerStatus,
) => {
  return filledOutFields.reduce((result, current) => {
    const { field, answer } = current;

    return answer && answer.status === status ? [...result, field.id] : result;
  }, [] as number[]);
};
